"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeContentPackagesClient = void 0;
const ContentPackagesClient_1 = require("./ContentPackagesClient");
class FakeContentPackagesClient {
    constructor() {
        this.contentPackages = [];
    }
    getAll(query, sort) {
        let packages = query
            ? this.contentPackages.filter((it) => it.name.includes(query))
            : this.contentPackages;
        if (sort === ContentPackagesClient_1.ContentPackageSort.NAME_ASC) {
            packages = packages.sort((a, b) => this.sortFieldsAlphabetically(a.name, b.name));
        }
        else if (sort === ContentPackagesClient_1.ContentPackageSort.NAME_DESC) {
            packages = packages.sort((a, b) => this.sortFieldsAlphabetically(b.name, a.name));
        }
        return Promise.resolve(packages);
    }
    create(contentPackage) {
        if (!contentPackage.id) {
            contentPackage.id = Math.random().toString();
        }
        this.contentPackages.push(contentPackage);
        return Promise.resolve(contentPackage.id);
    }
    clear() {
        this.contentPackages = [];
    }
    get(id) {
        const contentPackage = this.contentPackages.find((it) => it.id === id);
        if (contentPackage) {
            return Promise.resolve(contentPackage);
        }
        else {
            return Promise.reject(`Package with id ${id} not found`);
        }
    }
    getForFake(id) {
        return this.contentPackages.find((it) => it.id === id);
    }
    replace(id, contentPackageRequest) {
        const contentPackage = this.contentPackages.find((it) => it.id === id);
        if (contentPackage) {
            contentPackageRequest['id'] = id;
            this.contentPackages[this.contentPackages.indexOf(contentPackage)] =
                contentPackageRequest;
            return Promise.resolve(contentPackageRequest);
        }
        else {
            return Promise.reject(`Package with id ${id} not found`);
        }
    }
    sortFieldsAlphabetically(a, b) {
        if (a < b) {
            return -1;
        }
        if (a > b) {
            return 1;
        }
        return 0;
    }
}
exports.FakeContentPackagesClient = FakeContentPackagesClient;
//# sourceMappingURL=FakeContentPackagesClient.js.map